<template>
  <div>
    <div
    v-if="action === 'delete'"
    class="group-approve">
      <span class="group-approve__title">{{ `${$t('delete_channel')} ${group.name}?` }}</span>
      <div class="group-approve__button-block">
        <TJButton
        :text="$t('delete')"
        @handler="deleteGroup" />
        <TJButton
        :text="$t('cancel')"
        type="outlined"
        @handler="closeApprove" />
      </div>
    </div>
    <div
    v-if="action === 'addToBan'"
    class="group-approve">
      <span class="group-approve__title">{{ `Укажите причину бана для канала ${group.name}` }}</span>
      <input
      v-model="banReason"
      placeholder="Причина бана"
      class="group-approve__input">
      <div class="group-approve__button-block">
        <TJButton
        text="Забанить"
        @handler="addToBan" />
        <TJButton
        :text="$t('cancel')"
        type="outlined"
        @handler="closeApprove" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupApproveModal',
  // Компонент для подтверждения действий с группой: Удаление, Добавление в бан и тд
  props: {
    group: {
      type: Object,
      default: null,
    },
    action: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    banReason: '',
  }),
  methods: {
    closeApprove() {
      this.banReason = '';
      this.$emit('close');
    },
    deleteGroup() {
      const currentId = [this.group.id];
      this.$store.dispatch('groups/deleteGroup', { id: currentId, social: this.group.social })
        .then(() => {
          this.$store.dispatch('app/setSnackBar', { text: this.$t('successfully_the_channel_was_removed_from_the_database') });
        })
        .catch(() => {
          this.$store.dispatch('app/setSnackBar',
            {
              text: this.$t('an_error_occurred_when_deleting_the_channel_refresh_the_page_and_try_again'),
              error: true,
            });
        })
        .finally(() => this.closeApprove());
    },
    addToBan() {
      const params = {
        id: this.group.id,
        social: this.group.social,
        reason: this.banReason,
      };
      this.$store.dispatch('groups/addToBan', params)
        .then(() => {
          this.$store.dispatch('app/setSnackBar', { text: this.$t('Successfully. The channel will be banned') });
        })
        .catch(() => {
          this.$store.dispatch('app/setSnackBar',
            {
              text: this.$t('An error occurred while updating the data'),
              error: true,
            });
        })
        .finally(() => this.closeApprove());
    },
  },
};
</script>

<style lang="scss" scoped>
.group-approve {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @include between-elements {
    margin-bottom: 20px;
  }
}

.group-approve__button-block {
  padding-top: 20px;
  display: flex;
  @include between-elements {
    margin-right: 20px;
  }
}

.group-approve__input {
  padding: 0px 10px;
  border: 1px solid $border-color-primary;
  border-radius: 8px;
  background: $primary-white;
  box-sizing: border-box;
  width: 30vw;
  min-width: 200px;
  max-width: 300px;
  font-size: 14px;
  margin-top: 5px;
  height: 40px;
  &:focus {
    outline: none;
    border-color: $border-color-focus;
  }
  &:hover {
    outline: none;
  }
}
</style>
